import { Navigate, useParams } from "react-router-dom";

/** The retired Job Diagnostics URLs (`/admin/job-diagnostics[/:jobId]`) open the Job Detail page, keeping the job. */
export const JobDiagnosticsRedirect: React.FC = () => {
	const { jobId } = useParams<{ jobId?: string }>();
	return <Navigate to={jobId ? `/jobs/${encodeURIComponent(jobId)}` : "/jobs"} replace />;
};
